"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";

/**
 * Advanced Marker Component using AdvancedMarkerElement
 * Requires Map ID to be configured in environment variables
 *
 * @param {Object} props
 * @param {Object} props.position - { lat: number, lng: number }
 * @param {Function} props.onDragEnd - Callback when marker is dragged
 */
export default function AdvancedMarker(t0) {
  const $ = _c(6);
  const {
    position,
    onDragEnd
  } = t0;
  const map = useMap();
  const markerRef = useRef(null);
  const markerLibrary = useMapsLibrary("marker");
  let t1;
  let t2;
  if ($[0] !== map || $[1] !== markerLibrary || $[2] !== onDragEnd || $[3] !== position) {
    t1 = () => {
      if (!map || !markerLibrary || !position) {
        return;
      }
      if (markerRef.current) {
        ;
        try {
          markerRef.current.map = null;
        } catch (t3) {
          const e = t3;
        }
        markerRef.current = null;
      }
      const AdvancedMarkerClass = markerLibrary.AdvancedMarkerElement || markerLibrary.AdvancedMarker;
      if (!AdvancedMarkerClass) {
        console.error("AdvancedMarker class not found on marker library:", markerLibrary);
        return;
      }
      const marker = new AdvancedMarkerClass({
        map,
        position: {
          lat: position.lat,
          lng: position.lng
        },
        draggable: true
      });
      markerRef.current = marker;
      const dragEndListener = marker.addListener ? marker.addListener("dragend", () => {
        const pos = marker.position ?? (marker.getPosition && marker.getPosition());
        if (!pos) {
          console.warn("Could not read marker position after drag");
          return;
        }
        const lat = typeof pos.lat === "function" ? pos.lat() : pos.lat;
        const lng = typeof pos.lng === "function" ? pos.lng() : pos.lng;
        if (onDragEnd) {
          onDragEnd({
            lat,
            lng
          });
        }
      }) : null;
      return () => {
        if (dragEndListener && typeof dragEndListener.remove === "function") {
          dragEndListener.remove();
        }
        if (markerRef.current) {
          ;
          try {
            markerRef.current.map = null;
          } catch (t4) {
            const e_0 = t4;
          }
          markerRef.current = null;
        }
      };
    };
    t2 = [map, markerLibrary, position, onDragEnd];
    $[0] = map;
    $[1] = markerLibrary;
    $[2] = onDragEnd;
    $[3] = position;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
}